angular.module('unergie.main')
.controller('optimizationValidationCtrl', ($sce, $scope, $filter, $uibModal, $stateParams, $timeout, MS, NgTableParams, DataAccess, CommonRegex, AuthService, ModalService,
    ApiUser, XmlParser, FileUploader, DataAccessSearch, AlertManager, MetaWatcher, BoFeaturesService, ContactInformationB2G, ErrorCatcher) => {
    $scope.selected = {}
    $scope.validation = {}
    $scope.warningMessages = []
    $scope.errorMessages = []

    $scope.optiType = 'TURPE'

    $scope.VALIDATION_STATUSES = {
        INITIAL: { label: 'En attente validation', class: 'orange' },
        VALIDATED: { label: 'Validée', class: 'green' },
        REFUSED: { label: 'Refusée', class: 'blue' },
        TRANSFORMED: { label: 'Appliquée', class: 'green' },
    }

    $scope.selectedOrg = undefined

    $scope.isAdmin = BoFeaturesService.isFeatureOn('validationAdmin')
    $scope.showTools = !BoFeaturesService.get('isEnvProd')

    $scope.affectableAccountsByOrg = {}

    $scope.orgContacts = ContactInformationB2G

    $scope.stopProp = (e) => {
        e.stopPropagation()
    }

    $scope.search = {
        brand: null,
    }

    $scope.emptyAccount = () => {
        $scope.search.brand = ''
        $scope.selected.account = null
    }

    $scope.spinners = {
        nbPrm: false,
    }

    $scope.popupValidationFields = {
        label: {
            label: 'Je confirme que :',
            type: 'label',
        },
        check1: {
            label: `Je valide l'intégralité des optimisations qui me sont proposées.`,
            type: 'checkbox',
            check: (template) => template.check1,
        },
        check2: {
            label: `Les recommandations réalisées sont faites sur mon historique de puissance et de consommation. ` +
                `Il est donc possible que celui-ci ne soit pas représentatif de ma consommation future.`,
            type: 'checkbox',
            check: (template) => template.check2,
        },
        check3: {
            label: `Les gains sont estimatifs et calculés sur la base des tarifs en vigueur.`,
            type: 'checkbox',
            check: (template) => template.check3,
        },
        check4: {
            label: `Être habilité(e) pour demander ces modifications contractuelles`,
            type: 'checkbox',
            check: (template) => template.check4,
        },
        check5: {
            label: `Enedis refusant toute modification de FTA pendant 12 mois, ` +
                `il me sera impossible de demander une nouvelle modification de FTA sur les PRM pour lesquels je demande une modification.`,
            type: 'checkbox',
            check: (template) => template.check5,
        },
        check6: {
            label: `En cas de diminution de puissance, il me sera possible de revenir à ma puissance actuelle. Toutefois cette prestation sera facturée par Enedis`,
            type: 'checkbox',
            check: (template) => template.check6,
        },
    }

    $scope.popupValidationTemplate = {}

    $scope.popupRefusalFields = {
        label: {
            label: 'Je confirme que :',
            type: 'label',
        },
        check1: {
            label: `Je refuse l'intégralité des optimisations qui me sont proposées.`,
            type: 'checkbox',
            check: (template) => template.check1,
        },
        check2: {
            label: `Être habilité(e) pour refuser ces propositions d'optimisation.`,
            type: 'checkbox',
            check: (template) => template.check2,
        },
    }

    $scope.popupRefusalTemplate = {}

    const reminderFieldsTemplate = {
        label: {
            label: (a) => `Un e-mail de relance de validation du périmètre sera envoyé au(x) destinataire(s) suivant(s) :`,
            type: 'label',
        },
    }

    $scope.reminderPayload = {}
    $scope.reminderFields = {}

    $scope.prepareReminderPayload = (account) => {
        $scope.reminderPayload = { account }
        $scope.reminderFields = _.cloneDeep(reminderFieldsTemplate)
        _.each(account.affectedAccounts, (a) => {
            $scope.reminderPayload[a.id] = (a.organization === account.organization && a.id !== AuthService.getAuth().uuid)
            $scope.reminderFields[a.id] = {
                label: a.mail,
                type: 'checkbox',
            }
        })
    }

    $scope.sendReminder = () => {
        const accounts = _.filter(_.map($scope.reminderPayload, (value, key) => (value === true) && key))
        return ApiUser.sendOptiValidationReminder(
            {
                id_account: $scope.reminderPayload.account.id,
                type: 'TURPE',
            },
            accounts
        ).$promise.then((result) => {
            AlertManager.success(result.message, 10000)
        }).catch(ErrorCatcher)
    }

    $scope.refreshAccount = (account) => {
        if (account) {
            $scope.search.brand = account.brand
            $scope.selected.account = account
        }
        MetaWatcher.notif('MNG_ACCOUNT_CHANGED')
    }

    $scope.optimizationsUploader = new FileUploader({
        url: `/api-user/optimization-validation/upload-xlsx`,
        alias: 'file',
        formData: [{ id_account: $scope.selected.account && $scope.selected.account.id, type: $scope.optiType }],
        autoUpload: true,
        method: 'POST',
        onBeforeUploadItem() {
            $scope.response = null
            $scope.errorMessage = null
            $scope.errorDetails = []
        },
        onSuccessItem(item, response) {
            AlertManager.success(`Choix importés, cliquez sur "Valider les choix importés" pour les sauvegarder`)
            const grouped = _.groupBy(response, (elem) => `${elem.status}>${elem.new_status || elem.status}`)
            $scope.response = {
                nbTotal: response.length,
                sumup: _.map(grouped, (list, modif) => {
                    const [status, new_status] = modif.split('>')
                    return { status, new_status, nb: list.length }
                }),
                list: response,
            }
        },
        onErrorItem(item, response, status, headers) {
            $scope.errorMessage = response.message
            $scope.errorDetails = _.castArray(response.detail)
        },
    })

    const fetchAccountInfo = () => {
        $scope.selected.optimizations = null
        $scope.selected.account.fetching = true
        return DataAccess.myOptimizableAccount({ id: $scope.selected.account.id, type: $scope.optiType }).$promise
        .then((accountDetails) => {
            const account = accountDetails.toJSON()
            account.optimizations = _.orderBy(account.optimizations, ['status', 'id_prm'], ['asc', 'asc'])
            account.optimizations.forEach(optim => {
                let htmlString = '';
                const recommendation = optim.recommendation;
                if (optim['class_powers'] && Object.keys(optim['class_powers']).length > 0) {
                    const keys = ['HPE', 'HCE', 'HPH', 'HCH', 'PTE'];
                    keys.forEach(key => {
                        if (recommendation[key] !== undefined && optim['class_powers'][key] !== undefined) {
                            htmlString += `${key}: ${optim['class_powers'][key]} → ${recommendation[key]} <br>`;
                        }
                    });
                }
                else if ('max_power' in recommendation) {
                    htmlString = `PS.: ${optim.max_power} → ${recommendation.max_power}`;
                }
                optim.recommendation.power_safe = $sce.trustAsHtml(htmlString);
            });
            _.assign($scope.selected.account, account)
            $scope.selected.optimizations = new NgTableParams({}, { dataset: account.optimizations })
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.selected.account.fetching = false
        })
    }

    const updateAccount = () => {
        if ($scope.selected.account) {
            fetchAccountInfo()
            $scope.optimizationsUploader.formData = [{ id_account: $scope.selected.account.id, type: $scope.optiType }]
            $scope.parseResult = undefined
        }
    }

    $scope.updatePage = () => {
        $scope.accountsTable = null
        $scope.updatingPage = true
        return ($scope.selectedOrg ? Promise.resolve($scope.selectedOrg) : DataAccess.myOrganizations().$promise
        .then((myOrganizations) => {
            $scope.organizations = myOrganizations
            if (myOrganizations.length === 1) {
                $scope.selectedOrg = myOrganizations[0]
                return myOrganizations[0].id
            }
        }))
        .then((organization) => {
            if (organization) {
                $scope.selectedOrgObject = _.find($scope.organizations, { id: organization })
                const orgType = $scope.selectedOrgObject.type
                $scope.orgContact = _.assign({}, $scope.orgContacts[`default_${orgType}`], $scope.selectedOrgObject.contact_infos)
                return DataAccess.myOptimizableAccounts({ organization, type: $scope.optiType }).$promise
                .then((accounts) => {
                    const selectedId = ($scope.selected.account && ($scope.selected.account.organization === organization) && $scope.selected.account.id) || $stateParams.id_account
                    $scope.accounts = accounts
                    if ($scope.accounts.length) {
                        if (!selectedId) {
                            $scope.selected = {
                                account: $scope.accounts[0],
                            }
                        } else {
                            $scope.selected = {
                                account: _.find($scope.accounts, { id: selectedId }),
                            }
                        }
                        if ($scope.accounts.length > 1 || $scope.isAdmin) {
                            $scope.accountsTable = new NgTableParams({}, { dataset: $scope.accounts })
                            const total = _.sumBy(accounts, 'validation.total')
                            const validated = _.sumBy(accounts, 'validation.validated')
                            const refused = _.sumBy(accounts, 'validation.refused')
                            $scope.validation = {
                                total,
                                validated,
                                refused,
                                percent: MS.round((100 * (validated + refused)) / total, 2),
                            }
                        }
                        $scope.refreshAccount($scope.selected.account)
                    } else {
                        $scope.selected.optimizations = null
                        $scope.selected.account = null
                    }
                })
                .catch(ErrorCatcher)
            }
        })
        .finally(() => {
            $timeout(() => {
                $scope.updatingPage = false
            })
        })
    }

    $scope.canValidate = () => {
        return !!$scope.response
    }


    $scope.validateOptimization = (noMail) => {
        $scope.validatingOptimization = true
        const payload = _.map(_.filter($scope.response.list, (elem) => elem.new_status && elem.new_status !== elem.status), (elem) => _.pick(elem, ['id', 'status', 'new_status']))
        return ApiUser.validateOptimization({ id_account: $scope.selected.account.id, noMail, type: $scope.optiType }, payload).$promise
        .then((result) => {
            AlertManager.success(`Choix validés`, 10000)
            $scope.response = null
            $scope.updatePage()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.validatingOptimization = false
        })
    }

    $scope.validateOptimizationAsIs = (refuse) => {
        $scope[`${refuse ? 'refusing' : 'validating'}OptimizationAsIs`] = true
        return ApiUser.validateOptimizationAsIs({ id_account: $scope.selected.account.id, status: refuse ? 'REFUSED' : 'VALIDATED', type: $scope.optiType }, {}).$promise
        .then((result) => {
            $scope.response = null
            AlertManager.success(`Optimisations ${refuse ? 'refusées' : 'validées'}`, 10000)
            $scope.updatePage()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope[`${refuse ? 'refusing' : 'validating'}OptimizationAsIs`] = false
        })
    }

    $scope.generateMockFields = {
        limit: {
            label: 'Nombre :',
            type: 'number',
            required: true,
        },
    }

    $scope.generateMockPayload = {
        limit: 50,
    }

    $scope.generateMock = () => {
        $scope.mocking = true
        return DataAccess.mockOptimizationForOrg({ organization: $scope.selectedOrg, type: $scope.optiType, limit: $scope.generateMockPayload.limit }, {}).$promise
        .then((result) => {
            AlertManager.success(`Cas de test créés : ${result.length}`)
            $scope.updatePage()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.mocking = false
        })
    }

    // IMPORT
    $scope.importUploader = new FileUploader({
        url: `/api-admin/s3-upload`,
        alias: 'file',
        formData: [{ bucketName: 'files', path: 'contract-optimizations-import' }],
        autoUpload: true,
        method: 'POST',
        onSuccessItem(item, response, status, headers) {
            AlertManager.success(`Fichier de virements uploadé - lancement du traitement`)
            $scope.parsing = true
            const payload = {
                source: 's3',
                bucket: response.bucket,
                type: 'contract-optimizations',
                filename: response.path,
            }
            return XmlParser.parsing(payload).$promise.then((result) => {
                ModalService.openModal({ type: 'resultModal', size: 'lg' }, { result })
                $scope.updatePage()
            })
            .catch(ErrorCatcher)
            .finally(() => {
                $scope.parsing = false
            })
        },
        onErrorItem(item, response, status, headers) {
            AlertManager.error(response.message, 10000)
        },
    })

    $scope.openJiraOverlay = () => ModalService.openModal({ type: 'jiraListModal', size: 'xlg' }, { myAccounts: $scope.accounts })

    MetaWatcher.watch('MNG_ACCOUNT_CHANGED', 'optimizationValidation', $scope, updateAccount)

    const activate = () => {
        $scope.updatePage()
    }

    activate()
})
